const PX_TO_MM = 25.4 / 96;
const A4_CONTENT_MM = 277;

export function printInvoice(source, mode) {
  document.getElementById("sm-print-root")?.remove();
  document.getElementById("sm-print-page")?.remove();
  const inv = source?.querySelector(".sm-invoice") || source;
  if (!inv) return window.print();
  const root = document.createElement("div");
  root.id = "sm-print-root";
  root.className = mode;
  root.appendChild(inv.cloneNode(true));
  document.body.appendChild(root);
  const hMm = root.offsetHeight * PX_TO_MM;
  const page = document.createElement("style");
  page.id = "sm-print-page";
  if (mode === "thermal") {
    page.textContent = `@page { size: 80mm ${Math.ceil(hMm) + 4}mm; margin: 0; }`;
  } else {
    page.textContent = "@page { size: A4; margin: 10mm; }";
    if (hMm > A4_CONTENT_MM) root.style.zoom = A4_CONTENT_MM / hMm;
  }
  document.head.appendChild(page);
  document.body.classList.add("sm-print-clone");
  const cleanup = () => { root.remove(); page.remove(); document.body.classList.remove("sm-print-clone"); };
  window.addEventListener("afterprint", cleanup, { once: true });
  window.print();
}
